import React from 'react';

// Tipos para las sub-secciones
type ProfileSubSection = 'fifa-card' | 'reviews';
type StatsSubSection = 'main-stats' | 'match-history' | 'tags';
type RewardsSubSection = 'badges';

export type TabType = 'profile' | 'stats' | 'rewards' | 'history';
export type SubSectionType = ProfileSubSection | StatsSubSection | RewardsSubSection | null;

interface ProfileTabsProps {
  activeTab: TabType;
  activeSubSection: SubSectionType;
  onTabChange: (tab: TabType, subSection?: SubSectionType) => void;
  isMobile?: boolean;
}

export const ProfileTabs: React.FC<ProfileTabsProps> = ({
  activeTab,
  activeSubSection,
  onTabChange,
  isMobile = false
}) => {
  const getSubSections = (tab: TabType) => {
    switch (tab) {
      case 'profile':
        return [
          { key: 'fifa-card' as ProfileSubSection, label: '⚽ FIFA Card', icon: '⚽' },
          { key: 'reviews' as ProfileSubSection, label: '📝 Reviews', icon: '📝' }
        ];
      case 'stats':
        return [
          { key: 'main-stats' as StatsSubSection, label: '📊 Estadísticas', icon: '📊' },
          { key: 'match-history' as StatsSubSection, label: '🎮 Historial', icon: '🎮' },
          { key: 'tags' as StatsSubSection, label: '🏷️ Tags', icon: '🏷️' }
        ];
      case 'rewards':
        return [
          { key: 'badges' as RewardsSubSection, label: '🏆 Logros', icon: '🏆' }
        ];
      default:
        return [];
    }
  };

  return (
    <div style={{
      backgroundColor: '#23272A',
      padding: isMobile ? '10px' : '24px',
      borderRadius: '18px',
      marginBottom: isMobile ? '8px' : '20px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
      border: '1px solid #33383B'
    }}>
      {/* Tabs principales */}
      <div style={{
        display: 'flex',
        gap: isMobile ? '4px' : '8px',
        marginBottom: isMobile ? '10px' : '16px',
        borderBottom: '1px solid #33383B',
        paddingBottom: isMobile ? '8px' : '10px'
      }}>
        <button
          onClick={() => onTabChange('profile', 'fifa-card')}
          style={{
            flex: 1,
            padding: isMobile ? '8px 12px' : '10px 16px',
            backgroundColor: activeTab === 'profile' ? '#00E676' : 'transparent',
            border: '1px solid #33383B',
            borderRadius: '8px',
            color: activeTab === 'profile' ? '#181A1B' : '#FFFFFF',
            cursor: 'pointer',
            fontSize: isMobile ? '12px' : '14px',
            fontWeight: '600',
            transition: 'all 0.2s ease'
          }}
        >
          👥 Perfil
        </button>

        <button
          onClick={() => onTabChange('stats', 'main-stats')}
          style={{
            flex: 1,
            padding: isMobile ? '8px 12px' : '10px 16px',
            backgroundColor: activeTab === 'stats' ? '#00E676' : 'transparent',
            border: '1px solid #33383B',
            borderRadius: '8px',
            color: activeTab === 'stats' ? '#181A1B' : '#FFFFFF',
            cursor: 'pointer',
            fontSize: isMobile ? '12px' : '14px',
            fontWeight: '600',
            transition: 'all 0.2s ease'
          }}
        >
          📊 Estadísticas
        </button>

        <button
          onClick={() => onTabChange('rewards', 'badges')}
          style={{
            flex: 1,
            padding: isMobile ? '8px 12px' : '10px 16px',
            backgroundColor: activeTab === 'rewards' ? '#00E676' : 'transparent',
            border: '1px solid #33383B',
            borderRadius: '8px',
            color: activeTab === 'rewards' ? '#181A1B' : '#FFFFFF',
            cursor: 'pointer',
            fontSize: isMobile ? '12px' : '14px',
            fontWeight: '600',
            transition: 'all 0.2s ease'
          }}
        >
          🏆 Recompensas
        </button>

        <button
          onClick={() => onTabChange('history')}
          style={{
            flex: 1,
            padding: isMobile ? '8px 12px' : '10px 16px',
            backgroundColor: activeTab === 'history' ? '#00E676' : 'transparent',
            border: '1px solid #33383B',
            borderRadius: '8px',
            color: activeTab === 'history' ? '#181A1B' : '#FFFFFF',
            cursor: 'pointer',
            fontSize: isMobile ? '12px' : '14px',
            fontWeight: '600',
            transition: 'all 0.2s ease'
          }}
        >
          📈 Historial
        </button>
      </div>

      {/* Sub-secciones (solo en móvil) */}
      {isMobile && activeTab !== 'history' && (
        <div style={{
          display: 'flex',
          gap: '6px',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }}>
          {getSubSections(activeTab).map((subSection) => (
            <button
              key={subSection.key}
              onClick={() => onTabChange(activeTab, subSection.key)}
              style={{
                padding: '6px 12px',
                backgroundColor: activeSubSection === subSection.key ? '#7C4DFF' : 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '20px',
                color: activeSubSection === subSection.key ? '#FFFFFF' : '#B0BEC5',
                cursor: 'pointer',
                fontSize: '11px',
                fontWeight: '500',
                transition: 'all 0.2s ease',
                minWidth: 'fit-content'
              }}
            >
              {subSection.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}; 